export default "/images/vendor/flag-icon-css/flags/1x1/tw.svg?8ea0b61c9cced533d851df6fc6ad4fb7";